import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { wipeNewClientState } from 'redux/modules/newAffiliate';
import NewAffiliateFormStep1 from './NewAffiliateFormStep1';
import NewAffiliateFormStep2 from './NewAffiliateFormStep2';
import { Spinner } from 'components';
import * as styles from './NewAffiliate.scss';
var NewAffiliate = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  wipeNewClientState: wipeNewClientState
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewAffiliate, _Component);

  var _super = _createSuper(NewAffiliate);

  function NewAffiliate() {
    _classCallCheck(this, NewAffiliate);

    return _super.apply(this, arguments);
  }

  _createClass(NewAffiliate, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.wipeNewClientState();
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          formStep = _this$props.formStep;
      return /*#__PURE__*/React.createElement("div", null, contractInfo ? /*#__PURE__*/React.createElement("div", null, formStep === 1 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement(NewAffiliateFormStep1, {
        contractInfo: contractInfo
      })), formStep === 2 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement(NewAffiliateFormStep2, {
        contractInfo: contractInfo
      }))) : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return NewAffiliate;
}(Component)) || _class);
export { NewAffiliate as default };